import { getValidationMethod } from "./utils";

export function buildInitialSubscriptionState(data = {}) {
  return {
    invoices: [],
    pendingApplication: undefined,
    subscription: {},
    school: {},
    user: {},
    ...data,
    form: {
      doValidation: false,
      showConfirm: false,
      started: false,
      values: {
        // Contact
        contactName: `${data.user?.firstname ?? ""} ${
          data.user?.surname ?? ""
        }`,
        contactEmail: data.user?.email ?? "",
        contactRole: "",
        contactRoleCustom: "",
        // School
        schoolName: data.school?.name ?? "",
        schoolType: "",
        schoolTypeCustom: "",
        schoolTrust: "",
        schoolNumberOfStudents: "",
        schoolPercentageFreeSchoolMeals: "",
        schoolNumberOfMathsTeachers: "",
        // Other
        rateRequested: "",
        otherInformation: "",
      },
      validity: {
        // Contact
        contactName: undefined,
        contactEmail: undefined,
        contactRole: undefined,
        contactRoleCustom: undefined,
        // School
        schoolName: undefined,
        schoolType: undefined,
        schoolTypeCustom: undefined,
        schoolTrust: undefined,
        schoolNumberOfStudents: undefined,
        schoolPercentageFreeSchoolMeals: undefined,
        schoolNumberOfMathsTeachers: undefined,
        // Other
        rateRequested: undefined,
        otherInformation: undefined,
      },
    },
  };
}

export default function subscriptionReducer(state, action) {
  switch (action.type) {
    case "add_invoice": {
      return {
        ...state,
        invoices: [action.payload, ...state.invoices],
      };
    }
    case "set_pending_application": {
      return {
        ...state,
        pendingApplication: action.payload,
      };
    }
    case "start_form": {
      return {
        ...state,
        form: {
          ...state.form,
          started: true,
        },
      };
    }
    case "update_form_value": {
      const { property, value } = action.payload;
      const updatedValues = {
        ...state.form.values,
        [property]: value,
      };
      let updatedValidity = state.form.validity;
      if (state.form.doValidation) {
        const validationMethod = getValidationMethod(property);
        updatedValidity = {
          ...state.form.validity,
          [property]: validationMethod(updatedValues),
        };
      }
      return {
        ...state,
        form: {
          ...state.form,
          values: updatedValues,
          validity: updatedValidity,
        },
      };
    }
    case "do_form_validation": {
      let updatedValidity = {};
      Object.keys(state.form.validity).forEach((property) => {
        const validationMethod = getValidationMethod(property);
        updatedValidity[property] = validationMethod(state.form.values);
      });
      return {
        ...state,
        form: {
          ...state.form,
          doValidation: true,
          validity: updatedValidity,
        },
      };
    }
    case "cancel_form": {
      const defaultState = buildInitialSubscriptionState(state);
      return {
        ...state,
        form: defaultState.form,
      };
    }
    case "show_form_confirm": {
      return {
        ...state,
        form: {
          ...state.form,
          showConfirm: true,
        },
      };
    }
    case "hide_form_confirm": {
      return {
        ...state,
        form: {
          ...state.form,
          showConfirm: false,
        },
      };
    }
    default: {
      return state;
    }
  }
}
